// pages/admin/ReturnList.tsx
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getAllReturnsAPI } from "../../../../api/adminReturnExchange.ts"; // Adjust path
import {
    BlockBetween,
    BlockContent,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    PreviewCard,
    ReactDataTable,
} from "../../../../components/Component";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";

const ReturnList = () => {
    const [returns, setReturns] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReturns = async () => {
            try {
                setLoading(true);
                const response = await getAllReturnsAPI();
                setReturns(response.data.data);
            } catch (error) {
                console.error("Failed to fetch returns:", error);
                toast.error("Failed to fetch returns");
            } finally {
                setLoading(false);
            }
        };

        fetchReturns();
    }, []);

    const columns = [
        {
            name: "Return ID",
            selector: (row) => row._id,
            cell: (row) => <span className="fw-bold">{row._id}</span>,
        },
        {
            name: "User",
            selector: (row) => `${row.userId.first_name} ${row.userId.last_name}`,
            cell: (row) => (
                <span className="text-muted">{`${row.userId.first_name} ${row.userId.last_name}`}</span>
            ),
            sortable: true,
        },
        {
            name: "Product",
            selector: (row) => row.productId.name,
            cell: (row) => <span>{row.productId.name}</span>,
        },
        {
            name: "Order ID",
            selector: (row) => row.orderId._id,
            cell: (row) => <span>{row.orderId._id}</span>,
        },
        {
            name: "Reason",
            selector: (row) => row.reason,
            cell: (row) => (
                <span>{row.reason.substring(0, 50)}{row.reason.length > 50 ? "..." : ""}</span>
            ),
        },
        {
            name: "Status",
            selector: (row) => row.status,
            cell: (row) => (
                <span className={`badge ${row.status === "Approved" ? "bg-success" : "bg-warning"}`}>
                    {row.status}
                </span>
            ),
            sortable: true,
        },
    ];

    return (
        <React.Fragment>
            <Head title="Return/Exchange List" />
            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h3" page>
                                Return/Exchange List
                            </BlockTitle>
                            <BlockDes className="text-soft">
                                <p>You have a total of {returns.length} return requests.</p>
                            </BlockDes>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <BlockContent>
                    <PreviewCard>
                        {loading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
                                <div className="text-center">
                                    <div
                                        className="spinner-grow text-primary"
                                        style={{ width: "3rem", height: "3rem" }}
                                        role="status"
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-3 text-muted">Loading return requests, please wait...</p>
                                </div>
                            </div>
                        ) : (
                            <ReactDataTable
                                data={returns}
                                columns={columns}
                                pagination
                                actions
                                expandableRows
                            />
                        )}
                    </PreviewCard>
                </BlockContent>
            </Content>
        </React.Fragment>
    );
};

export default ReturnList;